import * as React from "react";
import View from "../../../../View/index";
import createAnimatedComponent from "../createAnimatedComponent";
var AnimatedView_default = createAnimatedComponent(View);
export {
  AnimatedView_default as default
};
//# sourceMappingURL=AnimatedView.js.map
